import { render, staticRenderFns } from "./index.vue?vue&type=template&id=349cdfbc&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('349cdfbc')) {
      api.createRecord('349cdfbc', component.options)
    } else {
      api.reload('349cdfbc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=349cdfbc&", function () {
      api.rerender('349cdfbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/venueBooking/orderInformation/orderCheck/index.vue"
export default component.exports